import { ActionModal } from '@atoms/Modals';
import format from "date-fns/format";
import React from 'react';
import { CSVLink } from "react-csv";
import styled from 'styled-components';

type Columns = {
    label: string;
    key: string;
};

type Props = {
    listData?: any;
};

const openApplyColumn: Columns[] = [
    { label: '契約コード', key: 'contactId' },
    { label: '廃止申請OK日', key: 'relitRequestDate' },
    { label: 'マッチングOK日', key: 'supplyStartDate' },
    { label: '再点完了日', key: 'relitRequestDate' },
    { label: '契約日', key: 'supplyStartDate' },
    { label: 'スイッチング予定日', key: 'supplyStartDate' },
    { label: '課金開始日', key: 'supplyStartDate' }
];


const CsvDownloadOpenComplete = (props: Props) => {
    const fileNameDate = `swiching_complete_list_${format(new Date(), 'yyyyMMdd_HHmmss')}`;
    const { listData } = props;
    const { data, error, loading } = listData;
    const openRequestListData = data || [];

    return (
        <CsvDownloadWithStyled>
            {loading && ''}
            {error && ''}
            {data &&
                <ActionModal
                    title='再点 完了一覧CSVダウンロード'
                    body='再点　完了一覧をダウンロードします。よろしいですか？'
                    buttonText='CSVダウンロード(再点完了)'
                    buttonStyle='btn-primary'
                    element={<CSVLink className='btn btn-primary' filename={fileNameDate} headers={openApplyColumn} data={openRequestListData}>はい</CSVLink>}
                    disabled={!openRequestListData.length}
                />
            }
        </CsvDownloadWithStyled>
    );
};

const CsvDownloadWithStyled = styled.div`
`

export default CsvDownloadOpenComplete;